<html>
<head>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.css">
</head>

<body>
    <button class="border-0 bg-dark" style="cursor: pointer;">
        <i class="fa fa-cog"></i>

    </button>
</body>
</html>